export { default as LabeledStrongContent } from './labeled-strong-content';
